import script from "./DeliveryManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveryManager.vue?vue&type=script&setup=true&lang=ts"

import "./DeliveryManager.vue?vue&type=style&index=0&id=44c066a0&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44c066a0"]])

export default __exports__